import { Base, Divider, Tab, Tabs } from '@bitrise/bitkit';
import React, { FunctionComponent, useContext } from 'react';

import dataAtIds from '../../dataAtIds.json';
import { URLStateContext } from '../URLState/URLState';

const OverviewTimeRangeTabs: FunctionComponent = () => {
  const { overviewPeriod, updateUrlState } = useContext(URLStateContext);

  return (
    <Base>
      <Tabs>
        <Tab
          data-trace-at-id={dataAtIds.OverviewPeriodButtonDaily}
          active={overviewPeriod === 'daily'}
          onClick={() => updateUrlState({ overviewPeriod: 'daily' })}
        >
          Daily
        </Tab>

        <Tab
          data-trace-at-id={dataAtIds.OverviewPeriodButtonWeekly}
          active={overviewPeriod === 'weekly'}
          onClick={() => updateUrlState({ overviewPeriod: 'weekly' })}
        >
          Weekly
        </Tab>

        <Tab
          data-trace-at-id={dataAtIds.OverviewPeriodButtonMonthly}
          active={overviewPeriod === 'monthly'}
          onClick={() => updateUrlState({ overviewPeriod: 'monthly' })}
        >
          Monthly
        </Tab>
      </Tabs>
      <Divider color="gray-2" width="1px" />
    </Base>
  );
};

export default OverviewTimeRangeTabs;
